import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoFocus } from 'primeng/autofocus';
import { Button } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { take, tap } from 'rxjs';
import { CategoriesService } from 'src/app/categories/categories.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Component({
    selector: 'app-edit-category',
    imports: [Button, FloatLabel, InputText, ReactiveFormsModule, AutoFocus, FormsModule],
    templateUrl: './edit-category.component.html',
    styleUrl: './edit-category.component.scss',
})
export class EditCategoryComponent implements OnInit {
    categoryName: string;
    categoryId: number;
    mode: 'EDIT' | 'CREATE' = 'CREATE';
    private readonly toasterService = inject(ToasterService);
    private readonly categoryService: CategoriesService = inject(CategoriesService);
    private readonly dialogConfig: DynamicDialogConfig = inject(DynamicDialogConfig);
    private readonly dialogRef: DynamicDialogRef = inject(DynamicDialogRef);

    constructor() {}

    ngOnInit() {
        this.categoryName = this.dialogConfig.data.categoryName;
        this.categoryId = this.dialogConfig.data.categoryId;
        if (this.categoryId) {
            this.mode = 'EDIT';
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    save() {
        if (this.mode === 'EDIT') {
            this.categoryService
                .updateCategory(this.categoryId, { name: this.categoryName })
                .pipe(
                    take(1),
                    tap(() => {
                        this.toasterService.showSuccessToast('تم تحديث الفئة بنجاح');
                        this.dialogRef.close();
                    }),
                )
                .subscribe();
        } else if (this.mode === 'CREATE') {
            this.categoryService
                .createCategory({ name: this.categoryName })
                .pipe(
                    take(1),
                    tap(() => {
                        this.toasterService.showSuccessToast('تم انشاء الفئة بنجاح');
                        this.dialogRef.close();
                    }),
                )
                .subscribe();
        }
    }
}
